import { useId } from "react";

/**
 * The Lattice whale mark, drawn exactly as the owner's mockup
 * (WhaleFinal.dc.html, Oct 2026): same viewBox, paths, and strokes.
 * Colors are the whale tokens, so no hex lives here. The mark is the same on
 * light and dark surfaces; only the backdrop changes.
 *
 * Decorative: every placement pairs it with visible "Lattice" text, which
 * carries the accessible name.
 */

// The body outline, used both to paint and to clip the belly band.
export const WHALE_BODY_PATH =
  "M0,22 Q0,6 14,6 L25,6 Q31,6 33,12 L36,22 L39,12 Q41,6 47,6 L52,6 Q66,6 66,20 L66,112 Q66,148 100,150 L150,150 Q168,150 168,168 L168,196 Q168,214 150,214 L16,214 Q0,214 0,198 Z";

export default function WhaleLogo({ className }: { className?: string }) {
  const clipId = useId();
  return (
    <svg aria-hidden className={className} viewBox="-24 -14 204 244">
      <defs>
        <clipPath id={clipId}>
          <path d={WHALE_BODY_PATH} />
        </clipPath>
      </defs>
      <path className="fill-lattice-palette-whale-body" d={WHALE_BODY_PATH} />
      <rect
        className="fill-lattice-palette-whale-belly"
        clipPath={`url(#${clipId})`}
        height="30"
        width="120"
        x="60"
        y="192"
      />
      <g className="fill-lattice-palette-whale-belly">
        <circle cx="152" cy="157" r="2.5" />
        <circle cx="160" cy="160" r="2.5" />
      </g>
      <circle
        className="fill-lattice-palette-whale-cream"
        cx="146"
        cy="164"
        r="4.5"
      />
      <path
        className="stroke-lattice-palette-whale-cream"
        d="M167,176 Q150,181 124,173"
        fill="none"
        strokeLinecap="round"
        strokeWidth="3.5"
      />
      <g
        className="stroke-lattice-palette-whale-deep"
        fill="none"
        strokeLinecap="round"
        strokeWidth="3"
      >
        <path d="M96,198 Q128,196 160,197" />
        <path d="M92,204 Q128,203 160,204" />
        <path d="M96,210 Q130,209 158,210" />
      </g>
    </svg>
  );
}
